import React, { useEffect } from "react";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";



//  const Gallery = ({ coverImage, galleries }) => {
//   return (
//     <div className="row gx-2 mb-3 mb-md-5">
//       {/* Main Large Image = Cover */}
//       <div className="col-md-7">
//         <div className="msbx">
//           <img src={coverImage} alt="Main Cover" />
//         </div>
//       </div>

//       {/* Side Images = Galleries */}
//       <div className="col-md-5">
//         <div className="row gx-2 h-100 flex-column gap-2">
//           {/* Top side image */}
//           {galleries?.[0] && (
//             <div className="col-12 flex-fill">
//               <div className="msbx">
//                 <img src={galleries[0].image_url} alt="Gallery Top" />
//               </div>
//             </div>
//           )}

//           {/* Bottom 3 images */}
//           <div className="col-12">
//             <div className="row gx-2">
//               {galleries?.slice(1, 4).map((g, idx) => (
//                 <div key={g.id || idx} className="col-4">
//                   <div className="msbx">
//                     <img src={g.image_url} alt={`Gallery ${idx + 2}`} />
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };


const Gallery = ({ coverImage, galleries }) => {
  useEffect(() => {
    Fancybox.bind("[data-fancybox='gallery']", {
      Thumbs: {
        autoStart: false,
      },
      Toolbar: {
        display: ["zoom", "slideshow", "thumbs", "close"],
      },
    });

    return () => {
      Fancybox.destroy();
    };
  }, []);

  return (
    <div className="row gx-2 mb-3 mb-md-5">
      {/* Main Large Image = Cover */}
      <div className="col-md-7">
        <div className="msbx">
          <a
            href={coverImage}
            data-fancybox="gallery"
            data-caption="Main Cover"
          >
            <img src={coverImage} alt="Main Cover" />
          </a>
        </div>
      </div>

      {/* Side Images = Galleries */}
      <div className="col-md-5">
        <div className="row gx-2 h-100 flex-column gap-2">
          {/* Top side image */}
          {galleries?.[0] && (
            <div className="col-12 flex-fill">
              <div className="msbx">
                <a
                  href={galleries[0].image_url}
                  data-fancybox="gallery"
                  data-caption="Gallery Top"
                >
                  <img src={galleries[0].image_url} alt="Gallery Top" />
                </a>
              </div>
            </div>
          )}

          {/* Bottom 3 images */}
          <div className="col-12">
            <div className="row gx-2">
              {galleries?.slice(1, 4).map((g, idx) => (
                <div key={g.id || idx} className="col-4">
                  <div className="msbx">
                    <a
                      href={g.image_url}
                      data-fancybox="gallery"
                      data-caption={`Gallery ${idx + 2}`}
                    >
                      <img src={g.image_url} alt={`Gallery ${idx + 2}`} />
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
